import React from 'react';
import PreviewTitle from './PreviewTitle';
import {Box, Text} from '../../../../styled';
import HighlightMarker from '../../../../components/HighlightMarker/HighlightMarker';
import FileAttachments from '../../../../components/FileAttachments/FileAttachments';
import JiraSubtasks from './JiraSubtasks';
import JiraComments from './JiraComments';
import EntityIcon from '../../../../components/EntityIcon/EntityIcon';
import * as Styled from '../../ResultDetailsStyles';
import Feedback from '../../../../components/Feedback/Feedback';
import {DateTime} from 'luxon';


const Preview = ({ item }: any) => {
  let labels = [];
  const { fields } = item;
  if (fields.labels && fields.labels.length) {
    labels = fields.labels.map((l:string) => {
      const name = l.replace(/_/gm, ' ');
      return {
        name,
        url: `${item.jiraLink}/issues/?jql=labels = ${encodeURIComponent(l)}`
      }
    });
  }
  return (
    <Box
      overflow="hidden"
      display="flex"
      flexDirection="column"
    >
      <Box display="flex" alignItems="center">
        <Box mr={20}>
          <EntityIcon entityName={item.pl} />
        </Box>
        <PreviewTitle item={item} />
      </Box>
      <Box
        flex={1}
        overflow={'auto'}
      >
        <Box
          display="flex"
          flexDirection={['column', 'row']}
          alignItems="stretch"
          justifyContent="space-between"
          maxHeight="calc(100% - 25px)"
          marginTop={25}
        >
          <Box
            background="rgba(255, 255, 255, 0.4)"
            borderRadius="10px"
            padding={16}
            height="100%"
          >
            <HighlightMarker>
              <Text
                fontWeight={600}
              >
                {item.title}
              </Text>
              <Text

              >
                {item.description || 'No description available'}
              </Text>
            </HighlightMarker>
            {
              !!item.att && !!item.att.length &&
              <FileAttachments files={item.att} />
            }
            <HighlightMarker>
              <JiraSubtasks subtasks={fields.subtasks} />
              <JiraComments comments={fields.comment.comments} />
            </HighlightMarker>
          </Box>
          <Box
            height="auto"
            minWidth={360}
            width={360}
            mt={[20, null, 0]}
            ml={[0, 0, 20]}
            display="flex"
            flexDirection={['column', 'row', 'column']}
            justifyContent={['space-between']}
            alignItems={['flex-start', 'flex-end', 'stretch']}
          >
            <Box
              background="rgba(255, 255, 255, 0.4)"
              borderRadius="10px"
              padding={16}
              flex="1"
            >
              <Box
                display="grid"
                gridTemplateColumns="max-content auto"
                gridColumnGap={40}
                gridRowGap={10}
              >
                <div className="label">Assignee</div>
                <div>{item.assigneeName || 'None'}</div>
                <div className="label">Reporter</div>
                <div>{item.reporterName}</div>
                <div className="label">Priority</div>
                <div>
                  <span>
                    {fields.priority.iconUrl && <img height="18" width="18" src={fields.priority.iconUrl} alt='priority icon' />}
                    <span className="font-600" style={{ color: fields.priority.color || 'inherit', paddingLeft: 5 }}>
                      {item.priorityName}
                    </span>
                  </span>
                </div>
                <div className="label">Due Date</div>
                <div>{fields.duedate ? DateTime.fromISO(fields.duedate).toLocaleString(DateTime.DATE_MED) : 'None'}</div>
                <div className="label">Labels</div>
                <div>
                  {
                    labels.length ? labels.map((l:any) => (
                      <Styled.SimpleLink
                        key={l.url}
                        href={l.url}
                        target={'jira'}
                        style={{ padding: 5, marginRight: 5, background: 'rgb(240,242,242)', borderRadius: 6 }}
                      >
                        {l.name}
                      </Styled.SimpleLink>
                    )) : 'None'
                  }
                </div>
                <div className="label">Fix versions</div>
                <div>
                  {fields.fixVersions && fields.fixVersions.length ?
                    fields.fixVersions.map((v:any) => v.name || v).join(', ') :
                    'None'
                  }
                </div>
                <div className="label">
                  Created
                </div>
                <div>
                  {DateTime.fromISO(fields.created).toLocaleString(DateTime.DATE_MED)}
                </div>
                {fields.updated && (
                  <>
                    <div className="label">
                      Updated
                    </div>
                    <div>
                      {DateTime.fromISO(fields.updated).toRelative()}
                    </div>
                  </>
                )}
              </Box>
            </Box>
            <Box
              mt={25}
              display="flex"
              alignItems="center"
              justifyContent="flex-end"
            >
              <Styled.StyledAnchor
                className={`ModalFooterBtn Msg ${!item.issueLink ? 'Disabled' : ''}`}
                href={item.issueLink}
                target="jira"
              >
                Go to ticket
              </Styled.StyledAnchor>
              <Feedback contained item={item}/>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Preview;